import * as ACTION_TYPES from './actiontypes';

export const changeInputValue = (type, name) => value => ({
  type: ACTION_TYPES.CHANGE_INPUT_VALUE,
  payload: {
    type,
    name,
    value
  }
});

export const initRequest = () => ({
  type: ACTION_TYPES.INIT_REQUEST
});

export const initSuccess = result => ({
  type: ACTION_TYPES.INIT_SUCCESS,
  payload: {
    ...result
  }
});

export const initFailure = error => ({
  type: ACTION_TYPES.INIT_FAILURE,
  error
});

export const searchRequest = () => ({
  type: ACTION_TYPES.SEARCH_REQUEST
});

export const searchSuccess = numberOfEncounters => ({
  type: ACTION_TYPES.SEARCH_SUCCESS,
  payload: {
    numberOfEncounters
  }
});

export const searchFailure = error => ({
  type: ACTION_TYPES.SEARCH_FAILURE,
  error
});

export const getCodersRequest = () => ({
  type: ACTION_TYPES.GET_CODERS_REQUEST
});

export const getCodersSuccess = () => ({
  type: ACTION_TYPES.GET_CODERS_SUCCESS
});

export const getCodersFailure = error => ({
  type: ACTION_TYPES.GET_CODERS_FAILURE,
  error
});

export const selectCoder = coder => ({
  type: ACTION_TYPES.SELECT_CODER,
  payload: {
    coder
  }
});

export const removeCoder = coder => ({
  type: ACTION_TYPES.REMOVE_CODER,
  payload: {
    coder
  }
});

export const beginWorkRequest = () => ({
  type: ACTION_TYPES.BEGIN_WORK_REQUEST
});

export const beginWorkSuccess = () => ({
  type: ACTION_TYPES.BEGIN_WORK_SUCCESS
});

export const beginWorkFailure = error => ({
  type: ACTION_TYPES.BEGIN_WORK_FAILURE,
  error
});
